import { Outlet } from "react-router";

import InboxSidebar from "views/inbox/components/Inbox/InboxSidebar";

import "../Inbox.scss";

export default function InboxDesktopLayout() {
  return (
    <div className="d-flex align-items-start flex-direction-column h-100">
      <div className="inbox-boxes">
        <InboxSidebar />
        <Outlet />
      </div>
    </div>
  );
}
